import AppDialog from "components/AppDialog";
import UserCardResult from "components/UserCardList/components/UserCardResult";

const FullProfileDialog = ({
  open,
  onOpenChange,
  hit,
  activeTabName,
  collectionKey,
  showCareerTrackAnalysis = false,
}) => (
  <AppDialog
    open={open}
    onOpenChange={onOpenChange}
    className="flex max-h-[92vh] w-[92vw] max-w-[1200px] flex-col overflow-y-auto overflow-x-hidden rounded-lg px-6 pb-6 pt-10"
  >
    {open && hit ? (
      <UserCardResult
        activeTabName={activeTabName}
        collectionKey={collectionKey}
        hit={hit}
        showActions
        showCareerTrackAnalysis={showCareerTrackAnalysis}
      />
    ) : null}
  </AppDialog>
);

export default FullProfileDialog;
